import { jsx as e } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99961 10.7999V8.3999C5.99961 5.0862 8.68591 2.3999 11.9996 2.3999C15.3133 2.3999 17.9996 5.0862 17.9996 8.3999V10.7999C19.3251 10.7999 20.3996 11.8744 20.3996 13.1999V19.1999C20.3996 20.5254 19.3251 21.5999 17.9996 21.5999H5.99961C4.67413 21.5999 3.59961 20.5254 3.59961 19.1999V13.1999C3.59961 11.8744 4.67413 10.7999 5.99961 10.7999ZM15.5996 8.3999V10.7999H8.39961V8.3999C8.39961 6.41168 10.0114 4.7999 11.9996 4.7999C13.9879 4.7999 15.5996 6.41168 15.5996 8.3999Z",
    fill: "currentColor"
  }
);
export {
  o as default
};
